export default __webpack_public_path__ + "static/media/img_payment.db307274.svg";